import h from 'react-hyperscript';
import mirrorkey from 'mirrorkey';

import CardDefault from '../Card/CardDefault';
import CardTrialEnded from '../Card/CardTrialEnded';
import CardSubscriptionEnded from '../Card/CardSubscriptionEnded';

export const overlayTypes = mirrorkey(['TRIAL_ENDED', 'SUBSCRIPTION_ENDED', 'NONE', 'UNKNOWN']);

overlayTypes.DEFAULT = 'UNKNOWN';

const renderCardByType = type => {
  switch (type) {
    case overlayTypes.TRIAL_ENDED:
      return h(CardTrialEnded);
    case overlayTypes.SUBSCRIPTION_ENDED:
      return h(CardSubscriptionEnded);
    case overlayTypes.NONE:
      return h('div');
    default:
      return h(CardDefault);
  }
};

export default props => {
  const { type = overlayTypes.DEFAULT } = props;

  return h('.sbi-overlay-container', [
    h('.sbi-overlay-background'),
    h('.sbi-overlay-link-container', [renderCardByType(type)]),
  ]);
};



// WEBPACK FOOTER //
// ./src/components/Overlay/Overlay.js